import { useCallback } from 'react';
import { useSelectedStorey } from './storeys.hooks';
import { createShape } from '@shared/helpers/design/factories';
import { EMPTY_FROZEN_ARRAY } from '@shared/helpers/array.helpers';
import { Shape } from '@shared/models/design/storey.model';
import { SemiPartial } from '@shared/models/type-helpers.model';
import { mutateDesign } from '@shared/helpers/design/mutators';
import { useUpdateBuildingDesign } from './design.hooks';
import { getSelectedStoreyId } from '../store/design-store.hooks';
import { required } from '@shared/helpers/function.helpers';

export const useSelectedStoreyShapes = (): Shape[] => {
  const storey = useSelectedStorey();
  return storey?.shapes ?? EMPTY_FROZEN_ARRAY;
};

export const useAddShape = () => {
  const updateBuildingDesign = useUpdateBuildingDesign();
  return useCallback(
    async (shape: Parameters<typeof createShape>[0]) => {
      const selectedStoreyId = required(
        getSelectedStoreyId(),
        'No storey selected',
      );
      return updateBuildingDesign((design) =>
        mutateDesign.storey.shape.add(design, selectedStoreyId, shape),
      );
    },
    [updateBuildingDesign],
  );
};

export const useUpdateShapes = () => {
  const updateBuildingDesign = useUpdateBuildingDesign();
  return useCallback(
    async (...updates: SemiPartial<Shape, 'id'>[]) => {
      return updateBuildingDesign((design) =>
        mutateDesign.storey.many.shapes.update(design, ...updates),
      );
    },
    [updateBuildingDesign],
  );
};
